import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import ContextualHelp from "./ContextualHelp";

const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export default function EditorialIntro({
  title,
  context = "",
  helpTitle = "",
  helpText = "",
  helpBullets = [],
  icon = null,
  action = null,
  titleVariant = "h4",
  compact = false,
  sx = {},
}) {
  const hasHelp = Boolean(helpTitle && (helpText || helpBullets.length));

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems={{ md: "center" }}
      spacing={compact ? 1.25 : 1.75}
      sx={{ minWidth: 0, ...sx }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Stack direction="row" spacing={0.9} alignItems="center" flexWrap="wrap" useFlexGap>
          {icon ? <Box sx={{ color: BRAND.orange, display: "flex", flex: "0 0 auto" }}>{icon}</Box> : null}
          <Typography
            variant={titleVariant}
            sx={{
              fontWeight: 950,
              color: BRAND.dark,
              letterSpacing: "-.025em",
              lineHeight: 1.12,
              overflowWrap: "anywhere",
            }}
          >
            {title}
          </Typography>
          {hasHelp ? (
            <ContextualHelp
              compact
              title={helpTitle}
              text={helpText}
              bullets={helpBullets}
            />
          ) : null}
        </Stack>
        {context ? (
          <Typography
            sx={{
              color: "rgba(25,36,47,.62)",
              mt: 0.45,
              maxWidth: 760,
              fontSize: { xs: ".88rem", sm: ".94rem" },
              lineHeight: 1.45,
            }}
          >
            {context}
          </Typography>
        ) : null}
      </Box>
      {action ? (
        <Box
          sx={{
            flex: "0 0 auto",
            width: { xs: "100%", md: "auto" },
            "& > .MuiButton-root": { width: { xs: "100%", sm: "auto" } },
          }}
        >
          {action}
        </Box>
      ) : null}
    </Stack>
  );
}
